import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard, faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

function PaymentSuccessModal(props) {

    return (
        <Modal isOpen={props.open} toggle={props.toggle} keybourd={false} backdrop={'static'}>
            <ModalHeader>
                Payment Successful
            </ModalHeader>
            <ModalBody>
                <div>
                    Your payment was processed successfully.
                </div>
            </ModalBody>
            <ModalFooter>
                <Button className="btn-icon" color="danr-green" onClick={props.makeAnotherPayment}><FontAwesomeIcon icon={faCreditCard} /><span>Make Another Payment</span></Button>
                <Link className="button btn btn-icon btn-danr-green" color="danr-green" to={props.paymentUrl}><FontAwesomeIcon icon={faMoneyCheckAlt} /><span>Go to Payment</span></Link>
            </ModalFooter>
        </Modal>
    );
}

export default PaymentSuccessModal;